import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import '../../styles/CustomNavigation.css';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useAppSelector } from '@src/store/hooks';
import { setDefaultRestaurant, setRestaurants } from '../../store/reducers/branchReducer';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { ArrowDown, ArrowRight, ArrowUp } from '../Icons';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import ImageRender from '../ImageRender/ImageRender';
import { RESTAURANT } from '@src/Constants';
import { setCart } from '@src/store/reducers/marketPlaceReducer';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';

const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
	borderRadius: '0px !important',
	boxShadow: 'none !important',
	width: '100% !important',
	minHeight: ' 52px',
	background: 'white',
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));
interface Props {
	isDrawerOpen: boolean;
	handleDrawerOpen: () => void;
	restaurant: Array<{
		default: object;
		restaurants: Array<{
			email: string;
			customer_id: string;
			last_name: string;
			first_name: string;
			telephone: string;
			image: string;
			address: string;
			name: string;
			id: string;
		}>;
	}>;
}
export default function CustomDropdown({ isDrawerOpen, handleDrawerOpen, restaurant }: Props) {
	const { apiService }: any = React.useContext(ApplicationContext);
	const defaultRestaurant: any = useAppSelector((state) => state?.restaurant?.value?.default);
	const restaurants: any = useAppSelector((state) => state?.restaurant?.value?.restaurants);
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const { id } = useParams();
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const [selectedIndex, setSelectedIndex] = React.useState(Number(id));

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const handleMenuItemClick = (restaurants: Array<any>, id: number) => {
		const restaurant = restaurants?.find((item) => item?.id === id);
		dispatch(setDefaultRestaurant(restaurant));
		setSelectedIndex(restaurant?.id);
		setOpen(false);
		dispatch(setCart([]));
		// Update URL

		const newUrl = `/${
			currentUser?.type?.toLowerCase() === RESTAURANT ? 'restaurants' : 'suppliers'
		}/${restaurant?.id}`;
		navigate(newUrl);
		window.location.reload();
	};

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}
		setOpen(false);
	};

	// const getBranch = () => {
	// 	try {
	// 		if (currentUser?.type?.toLowerCase() === RESTAURANT) {
	// 			apiService.getRestaurants(
	// 				(response: AxiosResponse) => {
	// 					const data = response?.data?.data;
	// 					const restaurant = data.find((item: any) => item?.id === Number(id));

	// 					dispatch(setRestaurants(data));
	// 					dispatch(setDefaultRestaurant(restaurant));
	// 				},
	// 				(error: AxiosError) => {
	// 					window.displayError('Something went wrong!');
	// 				}
	// 			);
	// 		} else {
	// 			apiService.getAllSuppliers(
	// 				(response: AxiosResponse) => {
	// 					const data = response?.data?.data;
	// 					const restaurant = data.find((item: any) => item?.id === Number(id));

	// 					dispatch(setRestaurants(data));
	// 					dispatch(setDefaultRestaurant(restaurant));
	// 				},
	// 				(error: AxiosError) => {
	// 					window.displayError('Something went wrong!');
	// 				}
	// 			);
	// 		}
	// 	} catch (err) {
	// 		console.log(err);
	// 		window.displayError('Something went wrong!');
	// 	}
	// };

	React.useEffect(() => {
		if (restaurants?.length && id) {
			const restaurant = restaurants?.find((item: any) => item?.id === Number(id));
			dispatch(setDefaultRestaurant(restaurant));
		}
	}, []);

	return (
		<React.Fragment>
			<StyledButtonGroup ref={anchorRef} aria-label="split button" className="button__group">
				{isDrawerOpen && (
					<Button
						sx={{
							width: '100%',
							textAlign: 'left',
							height: '52px',
							border: '0px',
							borderRadius: '0px',
							':hover': {
								border: 'none',
							},
						}}
					>
						<img
							src={restaurant?.default?.image || '/placeholderImage.svg'}
							alt={restaurant?.default?.name}
							width={28}
							height={28}
							style={{
								border: '1px solid #EDEDED',
								borderRadius: '50%',
								width: '28px',
								height: '28px',
							}}
						/>
						{/* <ImageRender
							imageUrl="https://img.freepik.com/premium-vector/restaurant-retro-vintage-style-logo_642964-120.jpg?w=250"
							fallBackUrl="/placeholderImage.svg"
							fallbackImageSize={28}
							loaderSize={26}
							altText={restaurant?.default?.name}
							imageStyles={{
								border: '1px solid #EDEDED',
								borderRadius: '50%',
								width: '28px',
								height: '28px',
							}}
						/> */}
						<div
							style={{
								padding: '5px 8px',
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<Typography
								variant="body2"
								sx={{
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: '130px',
								}}
							>
								{restaurant?.default?.name || 'No restaurant selected'}
							</Typography>
							<Typography
								variant="body2"
								sx={{
									fontSize: '10px',
									lineHeight: '12px',
									color: '#7D7D7D',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: '130px',
								}}
							>
								{restaurant?.default?.address}
							</Typography>
						</div>
					</Button>
				)}
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={() => {
						handleDrawerOpen();
						handleToggle();
					}}
					sx={{
						width: isDrawerOpen ? '20%' : '100%',
						height: '52px',
						mr: 0,
						border: '0px',
						borderLeft: '1px solid #f1f1f1',
						borderRadius: '0px',
						':hover': {
							border: 'none',
						},
					}}
				>
					{!isDrawerOpen && !open ? <ArrowRight /> : open ? <ArrowUp /> : <ArrowDown />}
				</Button>
			</StyledButtonGroup>
			<Popper
				sx={{
					zIndex: 1,
					left: '0px',
					width: '100%',
					borderRadius: '0px',
					transform: 'translate3d(0px, -54px, 0px) !important',
					boxShadow: 'none !important',
					borderTopLeftRadius: '4px',
					borderTopRightRadius: '4px',
				}}
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'right top' : 'right bottom',
						}}
					>
						<Paper
							sx={{
								borderRadius: '0px !important',
								boxShadow: 'none !important',
								borderTopLeftRadius: '4px',
								borderTopRightRadius: '4px',
								height: '118px',
								borderTop: '1.5px solid #F1F1F1',
								overflowY: 'auto',
							}}
						>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									{restaurant?.restaurants?.map(
										(
											{
												id,
												name,
												address,
												image,
											}: { company_name: string; address: string; image: string },
											index: number
										) => (
											<MenuItem
												sx={{ height: '52px' }}
												key={id}
												selected={id === selectedIndex}
												onClick={(event) => handleMenuItemClick(restaurant?.restaurants, id)}
											>
												<img
													src={image || '/placeholderImage.svg'}
													alt={name}
													width={28}
													height={28}
													style={{
														border: '1px solid #EDEDED',
														borderRadius: '50%',
														width: '28px',
														height: '28px',
													}}
												/>
												{/* <ImageRender
													imageUrl={image}
													fallBackUrl="/placeholderImage.svg"
													fallbackImageSize={28}
													loaderSize={26}
													altText={name}
													imageStyles={{
														border: '1px solid #EDEDED',
														borderRadius: '50%',
														width: '28px',
														height: '28px',
													}}
												/> */}
												<div
													style={{
														padding: '5px 8px',
														display: 'flex',
														flexDirection: 'column',
													}}
												>
													<Typography
														variant="body2"
														sx={{
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															maxWidth: '150px',
														}}
													>
														{name}
													</Typography>
													<Typography
														variant="body2"
														sx={{
															fontSize: '10px',
															lineHeight: '12px',
															color: '#7D7D7D',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis',
															maxWidth: '150px',
														}}
													>
														{address}
													</Typography>
												</div>
											</MenuItem>
										)
									)}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</React.Fragment>
	);
}
